const InputField = (props) => {
  const {
    label,
    name,
    tabIndex,
    type,
    grid_length,
    onChange,
    value,
    readOnly = false,
  } = props;
  return (
    <>
      <label className='col-sm-4 col-form-label' htmlFor='licensePlate'>
        {label}
      </label>
      <div className={`col-sm-${grid_length}`}>
        <input
          type={type}
          className='form-control'
          placeholder={label}
          name={name}
          disabled={readOnly}
          tabIndex={tabIndex}
          value={value || ""}
          onChange={onChange}
        />
      </div>
    </>
  );
};
export default InputField;
